// extracted by mini-css-extract-plugin
export default {"section":"styles_section__DgO1r","headingWrapper":"styles_headingWrapper__HA06D","heading":"styles_heading__3htf3","icon":"styles_icon__7VoGI"};